export default __webpack_public_path__ + "static/slupsk-b5317519c7ea70895280e1c6cc4abb0d.png";